import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * White card that groups one dashboard section's content. The section's label
 * row (uppercase label + right-aligned controls) sits OUTSIDE the card on the
 * white page; only the content goes inside. A near-invisible hairline plus a
 * wide, faint lift (`shadow-lift`) separates it from the page without reading as
 * a drawn box. Interactive rows inside use a light tint, never a nested
 * shadowed card.
 */
export function DashboardPanel({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-[12px] border border-black/[0.06] bg-white p-4 shadow-lift",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
